import React, { memo } from 'react';
import { displays } from 'investira.react.lib';
import { validators } from 'investira.sdk';
import { Stack, Typography, CircularProgress } from 'investira.react.components';
import { EmpresaTemplate } from '../../../../components/templates';
import { SearchGlobal, B3Section, CvmSection, EmpresaInfoSection } from '../../../../components/organisms';
import { useEmpresasContext } from '../../../../contexts/EmpresasContext';
import { ESTADOS } from '../../../../enums';
import EmpresaHeader from '../EmpresaHeader';
// import B3Section from "./B3Section";
// import CvmSection from "./CvmSection";
import ContabilSection from './ContabilSection';
import AtivosSection from './AtivosSection';
import PrevidenciaSection from './PrevidenciaSection';
import EmpresasSection from './EmpresasSection';
import EmpresaCharts from './EmpresaCharts/EmpresaCharts';
import PerfilSection from './PerfilSection';
import RegioesSection from './RegioesSection';
import FinanceiroSection from './FinanceiroSection';
import RiscoSection from './RiscoSection';
import GrupoSection from './GrupoSection';
import GestorAdministrador from './GestorAdministrador';
const EmpresaOverview = memo(() => {
  const {
    state
  } = useEmpresasContext();
  const {
    pessoa,
    perfil,
    isPageLoading
  } = state;
  if (isPageLoading) {
    return <Stack sx={{
      height: '100%'
    }}>
        <Stack justifyContent="center" alignItems="center" flexGrow={1}>
          <CircularProgress />
        </Stack>
      </Stack>;
  }
  if (!validators.isEmpty(pessoa)) {
    return <EmpresaTemplate title={`${pessoa.pessoa_fantasia || pessoa.pessoa} - ${displays.cnpj(pessoa.cnpj)}`} description={`Descubra tudo sobre ${pessoa.pessoa_fantasia}: dados detalhados, resultados, balanços, pl, capital social, ativos e mais`} header={<EmpresaHeader preciseOption={false} />} searchComponent={<SearchGlobal pageIsLoading={isPageLoading} clearOnClose={true} /> //Search
    } maxWidth={'xl'}>
        <Stack direction={{
        xs: 'column',
        lg: 'row'
      }} sx={{
        gap: 2,
        marginTop: 4
      }}>
          <PerfilSection perfil={perfil} pessoa={pessoa} />

          {perfil.estados && <Stack sx={{
          flex: 1,
          minWidth: 0
        }} component="section" aria-label={`${pessoa.pessoa_fantasia || pessoa.pessoa}: Áreas de Atuação`}>
              <RegioesSection title="Áreas de Atuação" data={perfil.estados.filter(xItem => xItem && Object.keys(xItem).length > 0).map(xItem => ({
            'hc-key': `br-${xItem.sigla.toLowerCase()}`,
            value: xItem.percentual,
            name: ESTADOS[xItem.sigla] || xItem.sigla,
            y: xItem.percentual,
            metadata: {
              sigla: xItem.sigla,
              percentual: `${xItem.percentual}%`,
              atividade: xItem.atividade
            }
          }))} pessoa={pessoa} map="brasilMap" />
            </Stack>}
        </Stack>

        <GestorAdministrador pessoa={pessoa} />

        <ContabilSection key={`contabil-${pessoa.pessoa_id}`} pessoa={pessoa} />

        <Stack direction={{
        xs: 'column',
        lg: 'row'
      }} sx={{
        gap: 1
      }}>
          {perfil.receitas && <Stack sx={{
          flex: 1,
          minWidth: 0
        }}>
              <FinanceiroSection title="Receitas" data={perfil.receitas} pessoa={pessoa} />
            </Stack>}
          {perfil.despesas && <Stack sx={{
          flex: 1,
          minWidth: 0
        }}>
              <FinanceiroSection title="Despesas" data={perfil.despesas} pessoa={pessoa} />
            </Stack>}

          {perfil.riscos && <Stack sx={{
          flex: 1,
          minWidth: 0
        }}>
              <RiscoSection data={perfil.riscos} pessoa={pessoa} />
            </Stack>}
        </Stack>

        {/* {perfil.riscos && (
          <Stack direction={{ xs: "column", lg: "row" }} sx={{ gap: 2 }}>
            <Stack
              sx={{
                flex: 1,
                minWidth: 0,
              }}
            >
              <RiscoSection data={perfil.riscos} pessoa={pessoa} />
            </Stack>
          </Stack>
         )} */}

        <Stack direction={{
        xs: 'column',
        md: 'row'
      }} sx={{
        gap: 1,
        py: 2,
        flexWrap: 'wrap'
      }}>
          <Stack sx={{
          flex: 1,
          minWidth: 0
        }}>
            <EmpresaInfoSection pessoa={pessoa} />
          </Stack>
          {pessoa.grupo && <Stack sx={{
          flex: 1,
          minWidth: 0
        }}>
              <GrupoSection pessoa={pessoa} />
            </Stack>}
          {!validators.isEmpty(pessoa?.juridica?.previdencia) && <Stack sx={{
          flex: 1,
          minWidth: 0
        }}>
              <PrevidenciaSection pessoa={pessoa} />
            </Stack>}
          {!validators.isEmpty(pessoa?.b3) && <Stack sx={{
          flex: 1,
          minWidth: 0
        }}>
              <B3Section pessoa={pessoa} />
            </Stack>}
          {!validators.isEmpty(pessoa?.cvm) && <Stack sx={{
          flex: 1,
          minWidth: 0
        }}>
              <CvmSection pessoa={pessoa} />
            </Stack>}
        </Stack>

        <AtivosSection pessoa={pessoa} />
        <EmpresasSection pessoa={pessoa} />

        <EmpresaCharts />
      </EmpresaTemplate>;
  } else {
    return <Stack sx={{
      height: '100%'
    }}>
        <Stack justifyContent="center" alignItems="center" flexGrow={1}>
          <Typography variant="body2" color="textSecondary">
            Empresa não encontrada
          </Typography>
        </Stack>
      </Stack>;
  }
});
export default EmpresaOverview;
